import { render, staticRenderFns } from "./StudioTerminplan.vue?vue&type=template&id=0c64c70b&"
import script from "./StudioTerminplan.vue?vue&type=script&lang=js&"
export * from "./StudioTerminplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports